import React from "react";
import Chatbot from "./pages/Chatbot";
import "./App.css";




function App() {
  return (
    <div className="App">
      <Chatbot />
    </div>
  );
}

export default App;
